import {EmptyAlert} from '../EmptyAlert';
import {ErrorLoadingData} from '../ErrorLoadingData';
import {EmailData} from './Data';
import {EmailForm} from './Form';

const Email = {
	Data: EmailData,
	Form: EmailForm,
	Empty: EmptyAlert,
	Error: ErrorLoadingData,
};

export {Email};
